import ContactRoute from './contact.jsx'

export default ContactRoute;